var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27569_458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27569_458)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4075 41.1107V80.4335C22.4075 82.936 23.7579 85.254 25.9601 86.5052L60.4476 106.156C62.6498 107.408 65.3507 107.408 67.5529 106.156L102.04 86.5052C104.243 85.254 105.593 82.936 105.593 80.4335V41.1107C105.593 38.6082 104.243 36.2903 102.04 35.039L67.5529 15.3879C65.3507 14.1366 62.6498 14.1366 60.4476 15.3879L25.9601 35.039C23.7787 36.2903 22.4075 38.6082 22.4075 41.1107Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5414 68.3922L66.6176 81.7049C66.4722 82.0742 66.4722 82.4844 66.6176 82.8536L75.0733 105.766L84.8586 100.187L73.1204 68.3922C72.8503 67.6538 71.8115 67.6538 71.5414 68.3922Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3894 45.9924C81.1193 45.2539 80.0806 45.2539 79.8105 45.9924L74.8867 59.3051C74.7412 59.6743 74.7412 60.0846 74.8867 60.4538L88.744 97.9715L98.5293 92.392L81.3894 45.9924Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 16.8441C64.2493 16.8441 64.4778 16.9056 64.7064 17.0287L102.019 38.3003C102.456 38.5464 102.726 38.9977 102.726 39.49V82.0333C102.726 82.5256 102.456 82.9769 102.019 83.223L64.7064 104.515C64.4986 104.638 64.2493 104.7 64 104.7C63.7507 104.7 63.5222 104.638 63.2936 104.515L26.0014 83.2435C25.5651 82.9974 25.295 82.5461 25.295 82.0538V39.49C25.295 38.9977 25.5651 38.5464 26.0014 38.3003L63.3144 17.0287C63.5222 16.9056 63.7715 16.8441 64 16.8441ZM64 10.6287C62.6704 10.6287 61.3407 10.9774 60.1565 11.6544L22.8435 32.926C20.4751 34.2798 19 36.7824 19 39.49V82.0333C19 84.741 20.4751 87.264 22.8435 88.6179L60.1565 109.889C61.3407 110.566 62.6704 110.915 64 110.915C65.3296 110.915 66.6593 110.566 67.8435 109.889L105.157 88.6179C107.546 87.264 109 84.7615 109 82.0333V39.49C109 36.7824 107.525 34.2593 105.157 32.9055L67.8643 11.6544C66.6593 10.9774 65.3296 10.6287 64 10.6287Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3391 98.0126L42.7671 88.7408L49.6646 94.4023L43.2242 100.228L39.3391 98.0126Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8628 36.4541H51.4099C50.7035 36.4541 50.0595 36.8849 49.831 37.5413L29.554 92.4331L39.3393 98.0126L61.6731 37.5618C61.86 37.0285 61.4653 36.4541 60.8628 36.4541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4208 36.4541H67.9679C67.2615 36.4541 66.6175 36.8849 66.3889 37.5413L43.2241 100.228L53.0094 105.807L78.2103 37.5823C78.418 37.0285 78.0025 36.4541 77.4208 36.4541Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbBg);
export default __webpack_public_path__ + "static/media/arb_bg.86facb1e279afc05887778c15b610301.svg";
export { ForwardRef as ReactComponent };